/**
 * Career-timeline data for the /build cubie.
 *
 * Entries below come from João's public profile (LinkedIn, Play Store).
 * Several entries have `// TODO João:` markers — please replace the
 * placeholder text with the real year + a one-line pitch, then drop the
 * TODO. The timeline UI doesn't render TODO markers; they only show up
 * in the source.
 */

export type MilestoneCategory =
  | "now"
  | "role"
  | "project"
  | "education";

export interface Milestone {
  id: string;
  /** Display string for the year/range. Use "2026 →" for ongoing. */
  year?: string;
  title: string;
  category: MilestoneCategory;
  body: string;
  tags?: readonly string[];
  link?: string;
}

export const TIMELINE: readonly Milestone[] = [
  {
    id: "jgson",
    year: "2026 →",
    title: "JGson — independent studio",
    category: "now",
    body: "Building Cypher Bot (fintech SaaS), this site, and taking client work across the eight cubies. Spec-driven, mobile-first, accessibility-AA by default.",
    tags: ["Founder", "Spec-kit", "Cloudflare"],
  },
  {
    id: "tonic3",
    year: "Current",
    title: "Tonic3 — Senior mobile engineer",
    category: "role",
    body: "UX-driven engineering across mobile and immersive surfaces. Tonic3 is the UX division of W3 (Dallas / Dublin).",
    tags: ["Mobile", "UX", "AR"],
    link: "https://www.tonic3.com",
  },
  {
    id: "cubek",
    title: "Cubek",
    category: "project",
    body: 'Rubik\'s cube simulator on Google Play. AI Solver, "Rhythm Hints" pulse-light teaching system, AR Mode, stats tracking. The literal namesake of the cube on this site.',
    tags: ["Unity", "C#", "Play Store"],
    link: "https://play.google.com/store/apps/details?id=com.JGSON.Cubek",
  },
  {
    id: "cypher-bot",
    title: "Cypher Bot",
    category: "project",
    body: "Trading SaaS in progress — automation rules, market-data integration, terminal-style UI.",
    tags: ["SaaS", "Fintech", "Automation"],
    link: "https://app.cypher-bot.com",
  },
  {
    id: "nelogica-atr-ema",
    year: "2025",
    title: "ATR Trailing Stop com EMA",
    category: "project",
    body: "Indicator + signal strategy published on the Nelogica Profit Pro marketplace. EMA + ATR Trailing Stop, sensitivity-adjustable, optional Heikin Ashi smoothing, blue/red bar coloring on the trigger conditions, real-time alerts.",
    tags: ["NTSL", "Profit Pro", "Trading", "Nelogica"],
    link: "https://nelogica.com.br/estrategias?id=10748",
  },
  {
    id: "doodle-jump-adventure",
    year: "2019",
    title: "Doodle Jump Adventure",
    category: "project",
    body: "Mobile jump-action game in the Doodle Jump franchise (Lima Sky). Unity developer at Oktagon Games. Originally iOS + Android; retired from the official stores, still listed on QooApp.",
    tags: ["Unity", "C#", "Mobile", "Lima Sky"],
    link: "https://m-apps.qoo-app.com/en-US/app/10205",
  },
  {
    id: "magic-puzzle-quest",
    year: "2019",
    title: "Magic: Puzzle Quest",
    category: "project",
    body: "Match-3 + RPG on the Magic: The Gathering IP. Unity developer at Oktagon Games (Brazilian studio); published by D3 Publisher. iOS + Android.",
    tags: ["Unity", "C#", "Mobile", "Match-3", "RPG"],
    link: "https://play.google.com/store/apps/details?id=com.d3p.olympic",
  },
  {
    id: "guia-guine",
    title: "Guia Guiné",
    category: "project",
    // TODO João: year + one-line scope (region or topic the guide covers).
    // Public JGson release on Play Store (package com.jgson.guiaguine).
    body: "Mobile guide / reference app on Google Play. Independent JGson release.",
    tags: ["Android", "Mobile", "Play Store"],
    link: "https://play.google.com/store/apps/details?id=com.jgson.guiaguine",
  },
  {
    id: "puc-pr-pos",
    title: "PUC-PR — Pós-graduação",
    category: "education",
    // TODO João: year range.
    body: "Pós-graduação em Arquitetura de Software e Cybersegurança. Pontifícia Universidade Católica do Paraná.",
    tags: ["Software Architecture", "Cybersecurity"],
  },
];

export const CATEGORY_LABELS: Record<MilestoneCategory, string> = {
  now: "Now",
  role: "Roles",
  project: "Projects",
  education: "Education",
};

export const CATEGORY_ORDER: readonly MilestoneCategory[] = [
  "now",
  "role",
  "project",
  "education",
];

export function groupByCategory(
  timeline: readonly Milestone[],
): Record<MilestoneCategory, Milestone[]> {
  const out: Record<MilestoneCategory, Milestone[]> = {
    now: [],
    role: [],
    project: [],
    education: [],
  };
  for (const m of timeline) out[m.category].push(m);
  return out;
}
